/** * @file FormAttention */
<template>
  <p class="fz-12 fc-orange m-0"><i class="el-icon-warning-outline"></i> <slot /></p>
</template>

<script>
export default {}
</script>
